// 页面所处环境
declare const window: any;
let _etEnv: string = "prod";

let _orignUrl: string = window.location.origin;
// 生产
if (
  /marketing.dfcfs.com/gi.test(_orignUrl) ||
  /marketing.eastmoney.com/gi.test(_orignUrl) ||
  /marketinghd.eastmoney.com/gi.test(_orignUrl) ||
  /marketing.18.cn/gi.test(_orignUrl) ||
  /marketinghd.dfcfs.com/gi.test(_orignUrl) ||
  /marketing.dfcfs.cn/gi.test(_orignUrl) ||
  /zqhd.18.cn/gi.test(_orignUrl) ||
  /young.eastmoney.com/gi.test(_orignUrl)
) {
  _etEnv = "prod";
} else if (/devprod/i.test(window.location.href)) {
  _etEnv = "prod";
} else {
  _etEnv = "dev";
}

// 相关配置
const envObj = {
  dev: {
    actBaseUrl: "https://mkcs.dfcfs.com/finskillshub", // 活动默认接口服务
    mktcsc: "https://mktest.dfcfs.com/revert/mktcsc",
    actIndexUrl: "https://marketingcs.dfcfs.com/views/finskillshub",

     /** 资讯接口 */
    actTopicBaseUrl: "https://mkcs.dfcfs.com/gdjnh2025",
        /** 财富号接口 */
    followBaseUrl: "https://gbapi.eastmoney.com",
    env: _etEnv,
  },
  prod: {
    actBaseUrl: "https://mkapi2.dfcfs.com/finskillshub",
    mktcsc: "https://mkapi.dfcfs.com/mktcsc",
    actIndexUrl: "https://marketing.dfcfs.com/views/finskillshub",

    actTopicBaseUrl: "https://mkapi2.dfcfs.com/gdjnh2025",
      /** 财富号接口 */
    followBaseUrl: "https://gbapi.eastmoney.com",
    env: _etEnv,
  }
}[_etEnv];

export default envObj;
